const dataText = JSON.stringify({
    nodes:[
        { id: 'node1', x: 150, y: 80, style:{}, type:'circle', size:50,label:'圆形节点',labelCfg:{position:'center',style:{fill:'#4192ff', fontSize:13}} },
        { id: 'node2', x: 350, y: 100, style:{}, type:'circle', size:50,label:'圆形节点',labelCfg:{position:'center',style:{fill:'#4192ff', fontSize:13}} },
        { id: 'node3', x: 100, y: 200, style:{}, type:'circle', size:100,label:'圆形节点',labelCfg:{position:'center',style:{fill:'#4192ff', fontSize:13}} },
        { id: 'node4', x: 300, y: 200, style:{}, type:'rect', size:[100,50],label:'节点',labelCfg:{position:'center',style:{fill:'#4192ff', fontSize:13}} },
    ],
    edges: [{type: "quadratic",style: {stroke: "#ff3239", lineWidth: 2, lineDash: [0], endArrow: false},
        label: "曲线",
        labelCfg: {
            position: "middle",
            style: {
                fill: "#32a2ff",
                fontSize: 13
            }
        },
        id: "edge-0.82012915201941271650251034724",
        source: "node3",
        target: "node4"
    }]
})

export default {
    cptDataForm: {dataText: dataText, dataSource: 1, pollTime: 0},
    attribute:{
        draggable:true,refreshFlag:false,layout:'custom', rankdir:'TB'
    },
    interaction:{intType: 'none'}
}